import { createSelector } from "reselect";

import { ResourceTypeLink } from "@evergis/api";

import { RootState } from "../reducers";
import { SelectedResource } from "./catalog";
import { ResourceViewType } from "../../modules/Catalog/components/ViewType/types";

export const getFetchParams =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog && catalog.fetchParams[type];
export const getFilter =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].filter;
export const getCategory =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].category;
export const getSort =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].sort;
export const getOffset =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].offset;
export const getLimit =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].limit;
export const getGeometryFilter =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].geometryFilter;
export const getServiceTypeFilter =
  (type: ResourceTypeLink) =>
  ({ catalog }: RootState) =>
    catalog.fetchParams[type].types;
export const getViewType = ({ catalog }: RootState): ResourceViewType => catalog.viewType;
export const getSelected = ({ catalog }: RootState): SelectedResource[] => catalog.selected;
export const getAnySelected = createSelector(getSelected, selected => selected.length > 0);
export const isSelected =
  (resourceName: string) =>
  ({ catalog }: RootState) =>
    catalog.selected.some(({ name }) => name === resourceName);
